import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { NotificationDto } from 'src/app/interfaces/Dtos/notification-dto';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { Notifications } from 'src/app/services/shared/notifications.service';
import * as signalR from '@microsoft/signalr'
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'neoris-notifications-mini-area',
    templateUrl: './notifications-mini-area.component.html',
    styleUrl: './notifications-mini-area.component.css'
})
export class NotificationsMiniAreaComponent implements OnInit, OnDestroy {

    private _hubConnection: signalR.HubConnection
    public newNotifications: boolean = false
    notifications: NotificationDto[] = []; 
    private arraySites: any[] = []
    
    public showNotifications = true;

    public hubConnected = true
    public hubConnecting = false
    
    private isModalOpenSubscription: Subscription
    private showNotificationsSubscription: Subscription
    constructor(private notificationsService: Notifications,
        private controltowerservice: ControltowerService,
        private translate: TranslateService,
        private sanitizer: DomSanitizer
    ) {

        this.newNotifications = false
     }

    public hideMessageArea: boolean = false
    public isModalOpen: boolean = false
    private lang: string = "en";
    private onLanChange: Subscription

    ngOnInit(): void {
        this.onLanChange = this.translate.onLangChange.subscribe(s => {
            this.lang = s.lang
            console.log("lang change", this.lang)
          })
      
        this.getSites()
       

       
    }

    ngOnDestroy(): void {
        this.isModalOpenSubscription.unsubscribe();
        this.showNotificationsSubscription.unsubscribe();
        this.onLanChange.unsubscribe()  
    }

    connectionHub() {
        var hubUrl = environment.urlHubEventMonitor
        this._hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(hubUrl)
        .withAutomaticReconnect()
        .build()

        this._hubConnection.on('NewEventNotification', (data) => {
  
      
      var isNotificationSite = this.ValidateNotificationSite(data)
      var isNotificationUser = this.ValidateNotificationUsers(data)

      if (isNotificationSite) {

        if (isNotificationUser) {

          var firstImage = data.media[0]
          let objectURL = `data:image/${firstImage.extension};base64,` + firstImage.imageData;
          var image = this.sanitizer.bypassSecurityTrustUrl(objectURL);


          var notification = {
            EventId: data.eventId,
            SiteName: data.siteName,
            ClientId: "0",
            BusinessSiteId: "0",
            LocationName: data.incidentArea,
            EventDate: data.detectedDt,
            EventType: data.eventType.filter(f => f.localeCode == this.lang)[0].eventTypeName,
            IconUrl: data.iconUrl,
            ImageUrl: image as any
          }
          this.notifications.push(notification); 

            if(this.hideMessageArea == false){
                this.newNotifications = true;
              }
          } else {
            console.log("No es una notificación para el usuario logueado")
          }
        } else {
          console.log("No es una notificación para algún sitio del usuario logueado")
        }
  
  
  
        
  
      });
  
      this._hubConnection.onclose(() => {
        this.hubConnected = false;
        this.hubConnecting = false;
      });
  
      this._hubConnection.onreconnected(() => {
        this.hubConnected = true;
        this.hubConnecting = false;
      });
  
      this._hubConnection.onreconnecting(() => {
        this.hubConnected = false;
        this.hubConnecting = true;
      });
  
  
      this.startConnection();
    }

 
  
    private startConnection() {
      this._hubConnection.start().then(() => {
        this.hubConnected = true
      }).catch(
        () => this.hubConnected = false
      )
    }
  
    private ValidateNotificationSite(notificationData: any): boolean {
        const arraySitesId = this.arraySites.map(site => site.id)
        const containsSites = arraySitesId.includes(notificationData?.siteId)
        return containsSites;
      }

      private ValidateNotificationUsers(notificationData: any): boolean {

        const dataContacts = notificationData?.deviceAlerts.contacts || []
        const userName = JSON.parse(localStorage.getItem('ud'))[1].value
    
        console.log("userName", userName, dataContacts)
        const containsUsers = dataContacts.some(contact => contact.email == userName)
    
        return containsUsers;
    
      }

    private async getSites(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.controltowerservice.getSites().subscribe(
                {
                    next: (sites: any) => {

                        this.arraySites = sites
                        this.connectionHub()

                        resolve(true);
                    }, error: (error: HttpErrorResponse) => {
                        resolve(false);
                    }
                }
            )
        });
    }

    public hideAreaMessage() {
        this.hideMessageArea = !this.hideMessageArea;

        if(this.hideMessageArea == true){
            this.newNotifications = false
        }
    }

    public CloseNotification(notificacion) {
        this.notifications = this.notifications.filter(x => x.EventId != notificacion.EventId);

        if(this.notifications.length == 0){
            this.newNotifications = false;
        }   
      }

}
